import React from 'react';

import { TimerShown } from './TimerShown.js';
import { TimerHidden } from './TimerHidden.js';
import { TimerHiddenLanOver } from './TimerHiddenLanOver.js';


export class Timer extends React.Component {
  constructor(props) {
    super(props);


    this.state = {
      lanDate: this.props.lanDate,
      lanFinishedDate: this.props.lanFinishedDate,
      message: this.props.message,
      timerOverMessage: this.props.timerOverMessage,
      timerOverSubMessage: this.props.timerOverSubMessage,
      lanOverMessage: this.props.lanOverMessage,
      lanOverSubMessage: this.props.lanOverSubMessage,
    
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,

      dayText: "Dager",
      hourText: "Timer",
      minuteText: "Minutter",
      secondText: "Sekunder",


      showModal: false,  //Set to true when modal-button is clicked
      showTimer: true ,  //We want to hide the timer when it reaches 0, and display a welcome to LAN message
      lanOver: false    //We display another message when the LAN is finished, and no new time is set
    };

    //Bindings 

  }

  //Get initial timer time
  componentWillMount(){
    this.getTimeUntil(this.state.lanDate, this.state.lanFinishedDate);
  }



  //Update timer every second
  componentDidMount(){
   this.intervalId = setInterval( () => {this.getTimeUntil(this.state.lanDate, this.state.lanFinishedDate)}, 1000)
  }

//We stop the interval
  componentWillUnmount(){
    clearInterval(this.intervalId); 
  }



  //Get time until LAN starts!
  getTimeUntil(lanDate, lanFinishedDate){

    //lanDate minus current time
    const time = Date.parse(lanDate) - Date.parse(new Date());
    const finishedTime = Date.parse(lanFinishedDate) - Date.parse(new Date());
    
    //If timeleft until LAN and LAN is over time, then the LAN is over, and we have no new date
    if(time <= 0 && finishedTime <= 0)
    {
      this.setState({
        showTimer:false,
        lanOver: true
      })
      this.props.setLanOver();
    }
    //Else, if the time is less than 0, but the finishedtime is greater, then the LAN is going right now!
    else if (time <=0)
    {
      this.setState({
        showTimer:false
      })
      this.props.setLanGoing();
    }
    //Else we assume that both the above are false. I.E, the timer must greater than the end-time again :)
    //Timer is back on
    else{ 
      this.setState({
        showTimer:true,
        lanOver: false
      });
    }


    //We have ms, convert to S
    const seconds = Math.floor((time/1000)%60);
    //We have s, convert to m
    const minutes = Math.floor((time/1000/60)%60);
    //we have m, convert to h
    const hours = Math.floor(time/(1000*60*60)%24);
    //we have h, convert to d
    const days = Math.floor(time/(1000*60*60*24));



    this.setState({
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    });

    if(days === 1){
      this.setState({dayText: "Dag"});
    }
    else{
      this.setState({dayText:"Dager"});
    }
    if(hours === 1){
      this.setState({hourText: "Time"});
    }
    else{
      this.setState({hourText:"Timer"});
    }
    if(minutes === 1){
      this.setState({minuteText: "Minutt"});
    }
    else{
      this.setState({minuteText:"Minutter"});
    }
    if(seconds === 1){
      this.setState({secondText: "Sekund"});
    }
    else{
      this.setState({secondText:"Sekunder"});
    }

  }





  render() {
 
    return (
      
      
      <div className="timerContainer  col-centered">
      {this.state.showTimer === true  && <TimerShown days={this.state.days} hours={this.state.hours} minutes={this.state.minutes} seconds={this.state.seconds} dayText={this.state.dayText} hourText={this.state.hourText} minuteText={this.state.minuteText} secondText={this.state.secondText} message={this.state.message} />}
      {this.state.showTimer === false && this.state.lanOver === false && <TimerHidden timerOverMessage={this.state.timerOverMessage} timerOverSubMessage={this.state.timerOverSubMessage} />}
      {this.state.lanOver === true && <TimerHiddenLanOver lanOverMessage={this.state.lanOverMessage} lanOverSubMessage={this.state.lanOverSubMessage} />}


    
       
          
        

      </div>
    )
  }



}
export default Timer;



// WEBPACK FOOTER //
// ./src/Components/App/Timer.js